function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { api } from './configs/axiosConfig';
import { PLATFORM_HOST_KEY } from '../constants';
export var ConfigurationAPI = {
    // Get all configurations with optional type filter
    getConfigurations: function () {
        var _getConfigurations = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(type) {
            var params, response;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            params = type ? {
                                type: type
                            } : {};
                            _context.n = 1;
                            return api.get('/configuration', {
                                params: params
                            });
                        case 1:
                            response = _context.v;
                            return _context.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee);
        }));
        function getConfigurations(_x) {
            return _getConfigurations.apply(this, arguments);
        }
        return getConfigurations;
    }(),
    // Get configuration by ID
    getConfigurationById: function () {
        var _getConfigurationById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(id) {
            var response;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return api.get("/configuration/".concat(id));
                        case 1:
                            response = _context2.v;
                            return _context2.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee2);
        }));
        function getConfigurationById(_x2) {
            return _getConfigurationById.apply(this, arguments);
        }
        return getConfigurationById;
    }(),
    // Create new configuration
    createConfiguration: function () {
        var _createConfiguration = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(data) {
            var response;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return api.post('/configuration', data);
                        case 1:
                            response = _context3.v;
                            return _context3.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee3);
        }));
        function createConfiguration(_x3) {
            return _createConfiguration.apply(this, arguments);
        }
        return createConfiguration;
    }(),
    // Update configuration by ID
    updateConfiguration: function () {
        var _updateConfiguration = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(id, data) {
            var response;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return api.put("/configuration/".concat(id), data);
                        case 1:
                            response = _context4.v;
                            return _context4.a(2, response === null || response === void 0 ? void 0 : response.data);
                    }
            }, _callee4);
        }));
        function updateConfiguration(_x4, _x5) {
            return _updateConfiguration.apply(this, arguments);
        }
        return updateConfiguration;
    }(),
    // Delete configuration by ID
    deleteConfiguration: function () {
        var _deleteConfiguration = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(id) {
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.n) {
                        case 0:
                            _context5.n = 1;
                            return api["delete"]("/configuration/".concat(id));
                        case 1:
                            return _context5.a(2);
                    }
            }, _callee5);
        }));
        function deleteConfiguration(_x6) {
            return _deleteConfiguration.apply(this, arguments);
        }
        return deleteConfiguration;
    }(),
    // Get the platform host URL from System configuration
    getPlatformHost: function () {
        var _getPlatformHost = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6() {
            var bundle, _iterator, _step, config, item, _t, _t2;
            return _regenerator().w(function (_context6) {
                while (1)
                    switch (_context6.p = _context6.n) {
                        case 0:
                            _context6.p = 0;
                            _context6.n = 1;
                            return ConfigurationAPI.getConfigurations('System');
                        case 1:
                            bundle = _context6.v;
                            _iterator = _createForOfIteratorHelper(bundle.resource);
                            _context6.p = 2;
                            _iterator.s();
                        case 3:
                            if ((_step = _iterator.n()).done) {
                                _context6.n = 7;
                                break;
                            }
                            config = _step.value;
                            item = config.items.find(function (i) {
                                return i.key === PLATFORM_HOST_KEY;
                            });
                            if (!item) {
                                _context6.n = 6;
                                break;
                            }
                            if (!(typeof item.value === 'string')) {
                                _context6.n = 4;
                                break;
                            }
                            return _context6.a(2, item.value);
                        case 4:
                            if (!(_typeof(item.value) === 'object')) {
                                _context6.n = 5;
                                break;
                            }
                            return _context6.a(2, JSON.stringify(item.value));
                        case 5:
                            return _context6.a(2, String(item.value));
                        case 6:
                            _context6.n = 3;
                            break;
                        case 7:
                            _context6.n = 9;
                            break;
                        case 8:
                            _context6.p = 8;
                            _t = _context6.v;
                            _iterator.e(_t);
                        case 9:
                            _context6.p = 9;
                            _iterator.f();
                            return _context6.f(9);
                        case 10:
                            _context6.n = 12;
                            break;
                        case 11:
                            _context6.p = 11;
                            _t2 = _context6.v;
                        case 12:
                            return _context6.a(2, '');
                    }
            }, _callee6, null, [[2, 8, 9, 10], [0, 11]]);
        }));
        function getPlatformHost() {
            return _getPlatformHost.apply(this, arguments);
        }
        return getPlatformHost;
    }()
};
